<app-x-dropdown-wrapper [options]="options" [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [disabled]="disabled">
  <div class="select-body" [class.borderless]="appearance === 'borderless'">
    <svg-icon *ngIf="leadingIcon" [name]="leadingIcon"></svg-icon>

    <app-x-label-padding class="select-label" [orientation]="'both'">{{ selectedText }}</app-x-label-padding>

    <svg-icon [name]="'caret-down-outline'"></svg-icon>
  </div>
</app-x-dropdown-wrapper>
